import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import _ from 'lodash';

class TestimonialBanner extends React.Component {
  getTestimonial() {
    if (!this.testimonial && this.props.widget) {
      this.testimonial = _.sample(this.props.widget.testimonials);
    }

    return this.testimonial;
  }

  render() {
    const testimonial = this.getTestimonial();

    if (!testimonial) {
      return null;
    }

    return (
      <div className="testimonial">
        <div className="container">
          <div className="wrapper col-md-8 ml-auto mr-auto">
            <div className="icon" />
            <div className="lines" />
            <div className="content">
              <p>
                {testimonial.message}
              </p>
            </div>
            <div className="lines d-none d-md-block" />
            <div className="source-box-wrapper">
              <div className="source-box">
                {testimonial.name}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TestimonialBanner.propTypes = {
  widget: PropTypes.object,
};

TestimonialBanner.defaultProps = {
  widget: undefined,
};

export default withData({
  widget: 'testimonials',
})(TestimonialBanner);



// WEBPACK FOOTER //
// ./src/components/TestimonialBanner/index.js